// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"601":"6e92de98","734":"61e900c9"}[chunkId] + ".chunk.js";
};